import { Link } from 'react-router-dom';

const demos = [
  {
    name: 'Smart Routine Coach',
    description:
      'Voice-activated morning routine management for kids with ADHD. Try the parent dashboard and kid view — no sign-up required.',
    url: 'https://smartroutinecoach.edg3labs.com',
    image: '/images/products/pulse-routine-coach-1.png',
    tags: ['Alexa Skill', 'Parent Dashboard', 'Kid View'],
  },
];

export function DemosPage() {
  return (
    <div>
      <div className="mb-2">
        <Link to="/" className="font-display text-sm text-gray-500 hover:text-white transition-colors">
          &larr; Home
        </Link>
      </div>

      <h1 className="font-display text-4xl font-bold text-white mb-2 sm:text-5xl">
        <span className="text-gradient-green">Try</span> Before You Buy
      </h1>
      <p className="text-gray-400 mb-10 text-lg">
        Try our apps before they launch — no account needed.
      </p>

      <div className="space-y-6">
        {demos.map((demo) => (
          <div
            key={demo.name}
            className="glass-card group flex flex-col overflow-hidden rounded-2xl border border-white/[0.06] transition-all duration-300 hover:border-teal-500/30 hover:shadow-xl hover:shadow-teal-500/10 md:flex-row"
          >
            {demo.image && (
              <div className="aspect-video overflow-hidden bg-navy-950 md:w-1/2">
                <img
                  src={demo.image}
                  alt={demo.name}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            )}
            <div className="flex flex-1 flex-col justify-center p-6 md:p-8">
              <h2 className="font-display text-xl font-semibold text-white mb-3">{demo.name}</h2>
              <div className="flex flex-wrap gap-2 mb-4">
                {demo.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-teal-500/10 px-3 py-0.5 text-xs font-medium text-teal-400"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <p className="text-sm text-gray-400 mb-6 leading-relaxed">{demo.description}</p>
              <a
                href={demo.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-fit items-center gap-2 rounded-xl bg-gradient-to-r from-teal-500 to-green-500 px-6 py-3 text-sm font-bold text-navy-950 transition-all hover:shadow-[0_0_20px_rgba(8,139,126,0.3)] active:scale-95"
              >
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                Launch Demo
              </a>
            </div>
          </div>
        ))}

        {/* Coming Soon placeholder */}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-white/10 p-12 text-center">
          <svg className="h-10 w-10 text-gray-600 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          <p className="text-lg font-semibold text-gray-500">Coming Soon</p>
          <p className="mt-1 text-sm text-gray-600">More demos are on the way. Check back soon!</p>
        </div>
      </div>
    </div>
  );
}
